export const PARKS_DATA = {
    disneylandPark: {
        name: "Disneyland Park",
        id: "dp",
        color: "pink",
        lands: [
            {
                name: "Main Street, U.S.A.",
                attractions: [
                    "Disneyland Railroad - Main Street Station",
                    "Main Street Vehicles",
                    "Horse-Drawn Streetcars",
                    "Liberty Arcade",
                    "Discovery Arcade"
                ]
            },
            {
                name: "Frontierland",
                attractions: [
                    "Big Thunder Mountain",
                    "Phantom Manor",
                    "Thunder Mesa Riverboat Landing",
                    "Rustler Roundup Shootin' Gallery",
                    "Disneyland Railroad - Frontierland Depot"
                ]
            },
            {
                name: "Adventureland",
                attractions: [
                    "Indiana Jones™ and the Temple of Peril",
                    "Pirates of the Caribbean",
                    "Adventure Isle",
                    "La Cabane des Robinson",
                    "Le Passage Enchanté d'Aladdin",
                    "Pirate Galleon"
                ]
            },
            {
                name: "Fantasyland",
                attractions: [
                    "Sleeping Beauty Castle (Le Château)",
                    "Peter Pan's Flight",
                    "It's a Small World",
                    "Dumbo the Flying Elephant",
                    "Mad Hatter's Tea Cups",
                    "Le Carrousel de Lancelot",
                    "Blanche-Neige et les Sept Nains (Snow White)",
                    "Les Voyages de Pinocchio",
                    "Casey Jr. – Le Petit Train du Cirque",
                    "Le Pays des Contes de Fées (Storybook Boats)",
                    "Alice's Curious Labyrinth",
                    "La Tanière du Dragon"
                ]
            },
            {
                name: "Discoveryland",
                attractions: [
                    "Star Wars Hyperspace Mountain",
                    "Star Tours: The Adventures Continue",
                    "Buzz Lightyear Laser Blast",
                    "Autopia",
                    "Orbitron",
                    "Les Mystères du Nautilus",
                    "Mickey’s PhilharMagic"
                ]
            }
        ]
    },
    wds: {
        name: "Disney Adventure World",
        id: "wds",
        color: "blue",
        lands: [
            {
                name: "World of Frozen",
                attractions: [
                    "Frozen Ever After"
                ]
            },
            {
                name: "Adventure Way",
                attractions: [
                    "Raiponce Tangled Spin"
                ]
            },
            {
                name: "Avengers Campus",
                attractions: [
                    "Avengers Assemble: Flight Force",
                    "Spider-Man W.E.B. Adventure"
                ]
            },
            {
                name: "Worlds of Pixar",
                attractions: [
                    "Crush's Coaster",
                    "Ratatouille: The Adventure",
                    "Cars ROAD TRIP",
                    "RC Racer",
                    "Slinky Dog Zigzag Spin",
                    "Toy Soldiers Parachute Drop",
                    "Cars Quatre Roues Rallye"
                ]
            },
            {
                name: "Production Courtyard",
                attractions: [
                    "The Twilight Zone Tower of Terror™",
                    "Stitch Live!"
                ]
            },
            {
                name: "Toon Studio",
                attractions: [
                    "Flying Carpets Over Agrabah",
                    "Animation Academy"
                ]
            }
        ]
    }
};

export const ENTERTAINMENT_DATA = {
    disneylandPark: {
        name: "Disneyland Park",
        sections: [
            {
                title: "Parades & Nighttime Spectaculars",
                items: [
                    "Disney Stars on Parade (Daily Parade)",
                    "Disney Electrical Sky Parade (Drone Show)",
                    "Disney Illuminations / Dreams (Fireworks)"
                ]
            },
            {
                title: "Stage Shows",
                items: [
                    "The Lion King: Rhythms of the Pride Lands",
                    "A Million Splashes of Colour (Seasonal)"
                ]
            },
            {
                title: "Character Meets",
                items: [
                    "Meet Mickey Mouse (Fantasyland)",
                    "Princess Pavilion (Fantasyland)",
                    "Meet Darth Vader (Discoveryland)",
                    "Meet Aladdin or Friends (Adventureland)",
                    "Meet Winnie the Pooh or Friends (Main Street)"
                ]
            }
        ]
    },
    wds: {
        name: "Disney Adventure World",
        sections: [
            {
                title: "Shows & Spectaculars",
                items: [
                    "A Celebration in Arendelle (World of Frozen)",
                    "Disney Cascade of Lights (Nighttime Spectacular)",
                    "Mickey and the Magician",
                    "Together: a Pixar Musical Adventure",
                    "Alice & the Queen of Hearts: Back to Wonderland",
                    "The Disney Junior Dream Factory"
                ]
            },
            {
                title: "Character Meets",
                items: [
                    "Royal Encounter with Anna & Elsa (World of Frozen)",
                    "Meet Olaf (World of Frozen)",
                    "Hero Training Center (Avengers Campus)",
                    "Meet Spider-Man (Avengers Campus)",
                    "Meet Jessie or Friends (Front Lot)"
                ]
            }
        ]
    }
};

export const HOTELS_DATA = [
    { name: "Disneyland Hotel", stars: 5, theme: "Royal" },
    { name: "Disney Hotel New York - The Art of Marvel", stars: 4, theme: "Marvel" },
    { name: "Disney Newport Bay Club", stars: 4, theme: "Nautical" },
    { name: "Disney Sequoia Lodge", stars: 3, theme: "National Park" },
    { name: "Disney Hotel Cheyenne", stars: 3, theme: "Wild West" },
    { name: "Disney Hotel Santa Fe", stars: 2, theme: "Route 66 / Cars" },
    { name: "Disney Davy Crockett Ranch", stars: 0, theme: "Nature Cabins" },
    { name: "Les Villages Nature Paris", stars: 4, theme: "Eco Resort" }
];
